export const cilResizeWidth = ["24 24","<path d='M17.164 18.375h-1.789v-3.375h-6.75v3.375h-1.811l-6.364-6.364 6.386-6.386h1.789v3.375h6.75v-3.375h1.811l6.364 6.364zM2.572 12.011l4.553 4.553v-3.064h9.75v3.042l4.553-4.553-4.553-4.553v3.064h-9.75v-3.042z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-resize-width.js
// module id = null
// module chunks = 